(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-carousel"] && !Shopify.designMode) return;
  try {
    
  class BlogCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cb-track');
      this.prevBtn = this.querySelector('.cb-prev');
      this.nextBtn = this.querySelector('.cb-next');
      this.firstCard = this.querySelector('.cb-card');
      if (!this.track || !this.firstCard) return;

      this.onNext = () => this.scrollByCard(1);
      this.onPrev = () => this.scrollByCard(-1);
      this.onScroll = () => this.updateButtons();

      this.nextBtn.addEventListener('click', this.onNext);
      this.prevBtn.addEventListener('click', this.onPrev);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtons();
    }

    scrollByCard(direction) {
      const cardWidth = this.firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
      this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 2;
    }

    disconnectedCallback() {
      this.nextBtn.removeEventListener('click', this.onNext);
      this.prevBtn.removeEventListener('click', this.onPrev);
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  if (!customElements.get('blog-carousel')) {
    customElements.define('blog-carousel', BlogCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-stacks"] && !Shopify.designMode) return;
  try {
    
  class FeaturedStacks extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fs-track');
      this.prevBtn = this.querySelector('.fs-prev');
      this.nextBtn = this.querySelector('.fs-next');
      this.firstCard = this.querySelector('.fs-card-slot');
      if (!this.track || !this.firstCard) return;

      this.onNext = () => this.scrollByCard(1);
      this.onPrev = () => this.scrollByCard(-1);
      this.onScroll = () => this.updateButtons();

      this.nextBtn.addEventListener('click', this.onNext);
      this.prevBtn.addEventListener('click', this.onPrev);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtons();
    }

    scrollByCard(direction) {
      const cardWidth = this.firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
      this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    updateButtons() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevBtn.disabled = this.track.scrollLeft <= 2;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 2;
    }

    disconnectedCallback() {
      this.nextBtn.removeEventListener('click', this.onNext);
      this.prevBtn.removeEventListener('click', this.onPrev);
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  if (!customElements.get('featured-stacks')) {
    customElements.define('featured-stacks', FeaturedStacks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-footer-col-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (window.innerWidth > 767) return;
        var col = toggle.closest('[data-footer-col]');
        col.classList.toggle('is-open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.review-carousel__viewport');
      this.track = this.querySelector('.review-carousel__track');
      this.prevBtn = this.querySelector('.is-prev');
      this.nextBtn = this.querySelector('.is-next');

      const realSlides = Array.from(this.querySelectorAll('.review-carousel__slide'));
      if (!this.track || realSlides.length === 0) return;

      this.count = realSlides.length;
      this.looping = this.count > 1;

      if (this.looping) {
        const firstClone = realSlides[0].cloneNode(true);
        const lastClone = realSlides[this.count - 1].cloneNode(true);
        [firstClone, lastClone].forEach((clone) => {
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          Array.from(clone.attributes).forEach((attr) => {
            if (attr.name.startsWith('data-shopify')) clone.removeAttribute(attr.name);
          });
        });
        this.track.insertBefore(lastClone, realSlides[0]);
        this.track.appendChild(firstClone);
        this.index = 1; // position 1 = first real slide (index 0 is the cloned-last)
      } else {
        this.index = 0;
      }

      this.slides = Array.from(this.track.children);

      this.onNext = () => this.go(this.index + 1);
      this.onPrev = () => this.go(this.index - 1);
      this.onResize = () => this.render(true);
      this.onTransitionEnd = () => this.settle();

      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      window.addEventListener('resize', this.onResize);
      this.track.addEventListener('transitionend', this.onTransitionEnd);

      this.render(true);

      const autoplay = this.dataset.autoplay === 'true';
      const delay = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      if (autoplay && this.looping) {
        this.timer = setInterval(this.onNext, delay);
      }
    }

    go(newIndex) {
      this.index = newIndex;
      this.render(false);
    }

    settle() {
      if (!this.looping) return;
      // Silently snap from a cloned boundary slide back to the matching real slide
      if (this.index === this.slides.length - 1) {
        this.index = 1;
        this.render(true);
      } else if (this.index === 0) {
        this.index = this.count;
        this.render(true);
      }
    }

    render(instant) {
      const step = this.viewport.getBoundingClientRect().width + this.gapPx();
      this.track.style.transition = instant ? 'none' : '';
      this.track.style.transform = `translateX(${-this.index * step}px)`;
      if (instant) {
        void this.track.offsetHeight;
        this.track.style.transition = '';
      }
    }

    gapPx() {
      const first = this.slides[0];
      if (!first) return 0;
      return parseFloat(getComputedStyle(first).marginRight) || 0;
    }

    disconnectedCallback() {
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      window.removeEventListener('resize', this.onResize);
      if (this.track) this.track.removeEventListener('transitionend', this.onTransitionEnd);
      if (this.timer) clearInterval(this.timer);
    }
  }

  if (!customElements.get('review-carousel')) {
    customElements.define('review-carousel', ReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stat-counter-grid"] && !Shopify.designMode) return;
  try {
    
  class StatCounterGrid extends HTMLElement {
    connectedCallback() {
      this.duration = parseInt(this.dataset.duration, 10) || 2000;
      this.counters = Array.from(this.querySelectorAll('.stat-counter__value'));
      if (this.counters.length === 0) return;

      this.observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.animateCounter(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );

      this.counters.forEach((counter) => this.observer.observe(counter));
    }

    animateCounter(el) {
      const target = parseInt(el.dataset.target, 10) || 0;
      const duration = this.duration;
      const startTime = performance.now();

      const step = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const value = Math.floor(progress * target);
        el.textContent = value;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target;
        }
      };
      requestAnimationFrame(step);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('stat-counter-grid')) {
    customElements.define('stat-counter-grid', StatCounterGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["word-reveal"] && !Shopify.designMode) return;
  try {
    
  class WordReveal extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.word-reveal__text');
      if (!this.textEl) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.textEl.classList.add('is-revealed');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.35 }
      );
      this.observer.observe(this.textEl);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('word-reveal')) {
    customElements.define('word-reveal', WordReveal);
  }

  } catch(e) { console.error(e); }
})();
})();
